import { ArrowLeftIcon, ArrowRightIcon } from '@eleveo/icons-react';
import { Button } from '@zoom/components';
import { startOfWeek, endOfWeek } from 'date-fns';
import { TFunction } from 'i18next';
import React from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import { Form } from 'reactstrap';

import { DatePickerField } from '.';
import { useAuth } from '../../app/AuthorizationProvider';
import { PickerType, DatePickerValueType } from './DatePicker';

interface WeekSwitcherBarProps {
  handlePreviousWeek: () => void;
  handleNextWeek: () => void;
  handleWeekChange: (value: DatePickerValueType) => void;
  pickedDate: Date | number;
  t: TFunction;
}

export const WeekSwitcherBar: React.FC<WeekSwitcherBarProps> = ({
  handlePreviousWeek,
  handleNextWeek,
  handleWeekChange,
  pickedDate,
  t,
}) => {
  const { localeObj } = useAuth();

  const date = pickedDate || new Date();

  const SelectedDateField = DatePickerField({
    dateFormat: t('date.formats.default'),
    label: t('date.selectedWeek'),
    dataTestId: 'input-weekpicker',
    noValidation: true,
    customOnChange: handleWeekChange,
    startDate: startOfWeek(date, { locale: localeObj }),
    endDate: endOfWeek(date, { locale: localeObj }),
    pickerType: PickerType.week,
  });

  return (
    <FinalForm
      initialValues={{ week: date }}
      onSubmit={() => ({})} // Value is controlled by state
      render={() => (
        <Form>
          <div className="week-picker-switch-bar">
            <Button
              data-test-id="button-previous-week"
              onClick={handlePreviousWeek}
              title={t('date.previousWeek')}
              kind="icon-bordered"
            >
              <ArrowLeftIcon className="text-chart-300" />
            </Button>
            <div className="week-picker-switch-bar__selected-week">
              <Field name="week" component={SelectedDateField} />
            </div>
            <Button
              data-test-id="button-next-week"
              onClick={handleNextWeek}
              title={t('date.nextWeek')}
              kind="icon-bordered"
            >
              <ArrowRightIcon className="text-chart-300" />
            </Button>
          </div>
        </Form>
      )}
    />
  );
};
